import { Injectable } from '@angular/core';

import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { DatabaseReference, DatabaseSnapshot, Query } from 'angularfire2/database/interfaces';

import { EventFeature } from '../models/event-feature';

@Injectable()
export class EventFeatureService {

  private databaseReference: DatabaseReference;

  constructor(private afDatabase: AngularFireDatabase) {
    this.databaseReference = afDatabase.database.ref('event-features');
  }

  getEventFeatures(eventId: string, query?: Query): FirebaseListObservable<EventFeature[]> {
    const databaseReference = this.databaseReference.child(eventId);
    return this.afDatabase.list(databaseReference, { preserveSnapshot: true, query: query })
      .map((eventFeaturesSnapshot: DatabaseSnapshot) => {
        const eventFeatures: EventFeature[] = [];

        eventFeaturesSnapshot.forEach(eventFeatureSnapshot => {
          const eventFeature = EventFeature.fromDatabaseSnapshot(eventFeatureSnapshot);

          if (eventFeature) {
            eventFeatures.push(eventFeature);
          }

          return false;
        });

        eventFeatures.sort((a, b) => (a.order || 0) - (b.order || 0));

        return eventFeatures;
      }) as FirebaseListObservable<EventFeature[]>;
  }

  async setEventFeatures(eventId: string, selectedFeatures: string[]) {

    const features = {
      'Tickets': {
        'key': 'ticket',
        'name': 'Ticket',
        'icon': 'ticket'
      },
      'Schedule': {
        'key': 'schedule',
        'name': 'Schedule',
        'icon': 'clock-o',
        'is_tab': true
      },
      'My Agenda': {
        'key': 'my-agenda',
        'name': 'My Agenda',
        'icon': 'filter',
        'is_tab': true
      },
      'Speakers': {
        'key': 'speakers',
        'name': 'Speakers',
        'icon': 'users',
        'is_tab': true
      },
      'News Feed': {
        'key': 'news-feed',
        'name': 'News Feed',
        'icon': 'rss',
        'is_tab': true
      },
      'Social Feed': {
        'key': 'social-feed',
        'name': 'Social Feed',
        'icon': 'rss',
        'is_tab': true
      },
      'Feedback Form': {
        'key': 'feedback-form',
        'name': 'Feedback Form',
        'icon': 'reorder'
      },
      'Trade X': {
        'key': 'trade-x',
        'name': 'Trade X',
        'icon': 'close',
        'is_tab': true
      },
      'Sponsors': {
        'key': 'sponsors',
        'name': 'Sponsors',
        'icon': 'handshake-o',
        'is_tab': true
      },
      'Exhibitors': {
        'key': 'exhibitors',
        'name': 'Exhibitors',
        'icon': 'handshake-o',
        'is_tab': true
      },
      'Leaderboard': {
        'key': 'leaderboard',
        'name': 'Leaderboard',
        'icon': 'bar-chart',
        'is_tab': true
      },
      'Documents': {
        'key': 'documents',
        'name': 'Documents',
        'icon': 'download',
        'is_tab': true
      },
      'FAQs': {
        'key': 'faqs',
        'name': 'FAQs',
        'icon': 'question-circle',
        'is_tab': true
      },
      'Networking': {
        'key': 'networking',
        'name': 'Networking',
        'icon': 'users',
        'is_tab': true
      },
      'Poll': {
        'key': 'poll',
        'name': 'Poll',
        'icon': 'list-ul',
        'is_tab': true
      },
      'Camera Filters': {
        'key': 'camera-filters',
        'name': 'Camera Filters',
        'icon': 'camera-retro',
        'is_tab': true
      }
    };

    if (selectedFeatures.length < 1) {
      throw Error('You must select atleast one feature.');
    }
    let order = 0;
    for (const feature of selectedFeatures) {
      if (features[feature]) {

        const eventFeatureObject: Object = {};

        eventFeatureObject[EventFeature.PropertyKey.name] = features[feature].name;
        eventFeatureObject[EventFeature.PropertyKey.icon] = features[feature].icon;
        eventFeatureObject[EventFeature.PropertyKey.order] = order;
        if (features[feature].is_tab) {
          eventFeatureObject['is_tab'] = true;
        }


        const featureKey = features[feature].key;
        // await this.getEventFeatures(eventId).push(eventFeatureObject);
        await this.afDatabase.database
          .ref(`event-features/${eventId}/${featureKey}`)
          .set(eventFeatureObject);
        order = order + 1;
      }
    }

  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/event-feature.service.ts